import { AccessLevelEnum } from '@zaoblako/shared/modules/security/enums/access.level.enum';
import { BrsAccessRulesKeyEnum } from '@zaoblako/web/core/models/enums/access-rules/brs/brs-access-rules-key.enum';

type AccessRuleExpression = Record<string, any>;

export const BrsAccessRulesConst: Record<BrsAccessRulesKeyEnum, AccessRuleExpression> = {
  // --- Модуль BRS (Платежи) ---

  // --- Раздел BRS.SECTIONS.BRS (Платежи) ---
  // Вкладки
  [BrsAccessRulesKeyEnum.BRS_BRS_TASK_READ]: {
    'BRS.enabled': true,
    'BRS.sections.BRS.tabs.TASK.accessLevel': { $gte: AccessLevelEnum.READ }
  },
  [BrsAccessRulesKeyEnum.BRS_BRS_TASK_WRITE]: {
    'BRS.enabled': true,
    'BRS.sections.BRS.tabs.TASK.accessLevel': { $gte: AccessLevelEnum.WRITE }
  },

  [BrsAccessRulesKeyEnum.BRS_BRS_DDS_READ]: {
    'BRS.enabled': true,
    'BRS.sections.BRS.tabs.DDS.accessLevel': { $gte: AccessLevelEnum.READ }
  },

  [BrsAccessRulesKeyEnum.BRS_BRS_PAYMENT_CALENDAR_READ]: {
    'BRS.enabled': true,
    'BRS.sections.BRS.tabs.PAYMENT_CALENDAR.accessLevel': { $gte: AccessLevelEnum.READ }
  },
  [BrsAccessRulesKeyEnum.BRS_BRS_PAYMENT_CALENDAR_WRITE]: {
    'BRS.enabled': true,
    'BRS.sections.BRS.tabs.PAYMENT_CALENDAR.accessLevel': { $gte: AccessLevelEnum.WRITE }
  },

  [BrsAccessRulesKeyEnum.BRS_BRS_TEMPLATE_READ]: {
    'BRS.enabled': true,
    'BRS.sections.BRS.tabs.TEMPLATE.accessLevel': { $gte: AccessLevelEnum.READ }
  },
  [BrsAccessRulesKeyEnum.BRS_BRS_TEMPLATE_WRITE]: {
    'BRS.enabled': true,
    'BRS.sections.BRS.tabs.TEMPLATE.accessLevel': { $gte: AccessLevelEnum.WRITE }
  },

  [BrsAccessRulesKeyEnum.BRS_BRS_STATUS_READ]: {
    'BRS.enabled': true,
    'BRS.sections.BRS.tabs.STATUS.accessLevel': { $gte: AccessLevelEnum.READ }
  },
  [BrsAccessRulesKeyEnum.BRS_BRS_STATUS_WRITE]: {
    'BRS.enabled': true,
    'BRS.sections.BRS.tabs.STATUS.accessLevel': { $gte: AccessLevelEnum.WRITE }
  },

  [BrsAccessRulesKeyEnum.BRS_BRS_SETTINGS_READ]: {
    'BRS.enabled': true,
    'BRS.sections.BRS.tabs.SETTINGS.accessLevel': { $gte: AccessLevelEnum.READ }
  },
  [BrsAccessRulesKeyEnum.BRS_BRS_SETTINGS_WRITE]: {
    'BRS.enabled': true,
    'BRS.sections.BRS.tabs.SETTINGS.accessLevel': { $gte: AccessLevelEnum.WRITE }
  },

  [BrsAccessRulesKeyEnum.BRS_BRS_PAYMENT_SCENARION_READ]: {
    'BRS.enabled': true,
    'BRS.sections.BRS.tabs.PAYMENT_SCENARION.enabled': true,
    'BRS.sections.BRS.tabs.PAYMENT_SCENARION.accessLevel': { $gte: AccessLevelEnum.READ }
  },
  [BrsAccessRulesKeyEnum.BRS_BRS_PAYMENT_SCENARION_WRITE]: {
    'BRS.enabled': true,
    'BRS.sections.BRS.tabs.PAYMENT_SCENARION.enabled': true,
    'BRS.sections.BRS.tabs.PAYMENT_SCENARION.accessLevel': { $gte: AccessLevelEnum.WRITE }
  },

  // Разрешения BRS
  [BrsAccessRulesKeyEnum.BRS_BRS_ACCESS_TO_ALL_SAVED_FILTERS]: {
    'BRS.enabled': true,
    'BRS.sections.BRS.permissions.ACCESS_TO_ALL_SAVED_FILTERS.isAllowed': true
  },
  [BrsAccessRulesKeyEnum.BRS_BRS_READ_ALL_TASKS]: {
    'BRS.enabled': true,
    'BRS.sections.BRS.permissions.READ_ALL_TASKS.isAllowed': true
  },
  [BrsAccessRulesKeyEnum.BRS_BRS_EDIT_OTHER_USERS_TASKS]: {
    'BRS.enabled': true,
    'BRS.sections.BRS.permissions.EDIT_OTHER_USERS_TASKS.isAllowed': true
  },
  [BrsAccessRulesKeyEnum.BRS_BRS_APPROVE_INSTEAD_OF_OTHERS]: {
    'BRS.enabled': true,
    'BRS.sections.BRS.permissions.APPROVE_INSTEAD_OF_OTHERS.isAllowed': true
  },
  [BrsAccessRulesKeyEnum.BRS_BRS_DELETE_OTHER_USER_TASK_COMMENTS]: {
    'BRS.enabled': true,
    'BRS.sections.BRS.permissions.DELETE_OTHER_USER_TASK_COMMENTS.isAllowed': true
  },
  [BrsAccessRulesKeyEnum.BRS_BRS_REFUSE_AGGREED_AND_SENT_TASKS]: {
    'BRS.enabled': true,
    'BRS.sections.BRS.permissions.REFUSE_AGGREED_AND_SENT_TASKS.isAllowed': true
  },
  [BrsAccessRulesKeyEnum.BRS_BRS_READ_ALL_PLANNED_INCOMES]: {
    'BRS.enabled': true,
    'BRS.sections.BRS.permissions.READ_ALL_PLANNED_INCOMES.isAllowed': true
  },
  [BrsAccessRulesKeyEnum.BRS_BRS_EDIT_OTHER_USERS_PLANNED_INCOMES]: {
    'BRS.enabled': true,
    'BRS.sections.BRS.permissions.EDIT_OTHER_USERS_PLANNED_INCOMES.isAllowed': true
  },
  [BrsAccessRulesKeyEnum.BRS_BRS_DELETE_OTHER_USER_PLANNED_INCOME_COMMENTS]: {
    'BRS.enabled': true,
    'BRS.sections.BRS.permissions.DELETE_OTHER_USER_PLANNED_INCOME_COMMENTS.isAllowed': true
  },
  [BrsAccessRulesKeyEnum.BRS_BRS_MAKE_PAID_UNDERPAYMENT_TASKS]: {
    'BRS.enabled': true,
    'BRS.sections.BRS.permissions.MAKE_PAID_UNDERPAYMENT_TASKS.isAllowed': true
  }
};
